/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import getFiltredProjectsActions, {
    getFiltredProjectsTypes,
} from '../../../redux/projects/filtredProject'
import { Get } from '../../../serveur/axios'

function* getFiltredProjectsSagas({ response }) {
    try {
        const {
            type,
            governorat,
            delegation,
            year,
            yearSecondary,
            typeProject,
            sector,
            projectManager,
        } = response
        let url = 'project_data/project-filtred?'
        if (type) url += `&type=${type}`
        if (governorat) url += `&governorat=${governorat}`
        if (delegation) url += `&delegation=${delegation}`
        if (year) url += `&year=${year}`
        if (yearSecondary) url += `&yearSecondary=${yearSecondary}`
        if (typeProject) url += `&typeProject=${typeProject}`
        if (sector) url += `&sector=${sector}`
        if (projectManager) url += `&projectManager=${projectManager}`
        const res = yield Get(url)
        if (res.status === 200 || res.status === 201) {
            yield put(
                getFiltredProjectsActions.getFiltredProjectsSuccess(
                    res.data.data
                )
            )
        } else {
            yield put(
                getFiltredProjectsActions.getFiltredProjectsFailure(
                    res.data.data
                )
            )
        }
    } catch (error) {
        yield put(getFiltredProjectsActions.getFiltredProjectsFailure(error))
    }
}

export function* getFiltredProjectsSaga() {
    yield takeLatest(
        getFiltredProjectsTypes.GET_FILTRED_PROJECTS_REQUEST,
        getFiltredProjectsSagas
    )
}
